import { tv } from 'tailwind-variants'

export const cellStyles = tv({
  base: 'relative flex justify-center',
  variants: {
    isFocusVisible: { true: 'z-10', false: 'z-0' },
  },
})

export const wrapperStyles = tv({
  base: 'font-base-copy text-primary group relative font-semibold outline-hidden',
  variants: {
    isHighlighted: { true: 'bg-lightblue' },
    isHighlightedStart: {
      true: 'after:bg-lightblue w-1/2 !bg-transparent after:absolute after:inset-y-0 after:left-1/2 after:right-0 *:aria-disabled:!opacity-100',
    },
    isHighlightedEnd: {
      true: 'after:bg-lightblue w-1/2 !bg-transparent after:absolute after:inset-y-0 after:left-0 after:right-1/2 *:aria-disabled:!opacity-100',
    },
    isHighlightedSameDay: { true: 'after:w-0' },
    isDisabled: { true: 'disabled !cursor-default' },
    isEmpty: { false: 'flex w-full justify-center' },
    hiddenMarkerStart: { true: 'rounded-l-2xl' },
    hiddenMarkerEnd: { true: 'rounded-r-2xl' },
  },
})

export const dateStyles = tv({
  base: 'flex size-10 items-center justify-center rounded-2xl',
  variants: {
    isDisabled: { true: 'opacity-30' },
    isFocusVisible: {
      true: 'group-focus:z-2 rounded-full ring-2 ring-offset-2',
    },
    isMarker: { true: 'bg-primary z-10 text-white' },
    hideRangeMarkers: { true: '!bg-lightblue !text-primary' },
    hoverHideRangeMarkers: { true: 'hover:!bg-primary hover:!text-white' },
    isHovered: { true: 'hover:bg-primary hover:text-white' },
    disabledCursor: { true: 'cursor-default', false: 'cursor-pointer' },
    todayMarker: { true: 'text-secondary-red' },
  },
})
